import { render } from "./TheList.vue?vue&type=template&id=50708d22&scoped=true"
import script from "./TheList.vue?vue&type=script&lang=js"
export * from "./TheList.vue?vue&type=script&lang=js"

import "./TheList.vue?vue&type=style&index=0&id=50708d22&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50708d22"]])

export default __exports__